// El panel de los permisos de tutor. Dos llamadas, las dos solo para administracion.
//
// POR QUE EXISTE ESTE PANEL. Un menor de catorce no entra hasta que consta quien dijo que si
// (art. 7 LOPDGDD), y hasta hoy eso se veia de dos maneras y ninguna era una pantalla: un
// script de terminal y un reloj nocturno. Con los treinta correos del instituto saliendo y
// OCHO de los treinta menores de catorce, hacia falta verlo sin abrir una terminal.
//
// EL ENVIO NO PASA POR AQUI, y es la decision de diseño: cuando un menor se registra y da el
// correo de su tutor, el permiso sale EN ESE MOMENTO, solo, como siempre. Si el envio esperara
// a que un adulto pulse un boton, el chaval que se registra un viernes por la noche no
// recibiria nada hasta el lunes, y su reloj de recordatorios -que arranca cuando el correo
// sale- empezaria a contar tarde. Este panel es para VER, y para pulsar en los casos que el
// reloj no puede resolver solo.
import { api } from "./client";

/** Los tres estados: solicitudes, validaciones pendientes y cuentas verificadas. */
export const traeLosPermisos = () =>
  api.get("/admin/permisos").then((r) => r.data);

/**
 * Pide, reenvia o corrige. Un solo boton para las tres cosas, porque son el mismo acto.
 *
 * Sin `email`, se le vuelve a pedir a la direccion que ya constaba. Con `email`, se corrige y
 * se pide a la nueva: un chaval que teclea mal el correo de su madre deja la cuenta esperando
 * para siempre, y esto es lo unico que lo arregla.
 *
 * Contesta `{ enviado, email }`. **El `false` importa tanto como el `true`**: si no hay
 * proveedor de correo configurado no sale nada, el servidor no apunta la fecha a proposito
 * -para no contar dias hacia el borrado sobre un correo que no existe- y la pantalla tiene que
 * poder decirlo en vez de dar por hecho que salio.
 */
export const pideElPermiso = (userId, email) =>
  api.post(`/admin/permisos/${userId}/pedir`, email ? { email } : {}).then((r) => r.data);

/**
 * Le escribe AL ALUMNO parado para que entre y deje el correo de su familia (13 oct 2026). Solo
 * dice eso: a un menor sin permiso no se le puede escribir de nada más. Una vez al día.
 */
export const pideAlAlumnoSuCorreo = (userId) =>
  api.post(`/admin/permisos/${userId}/pedir-al-alumno`).then((r) => r.data);

/** Borra entera una cuenta PARADA: la duplicada de quien se dio de alta otra vez. */
export const borraCuentaParada = (userId) =>
  api.delete(`/admin/permisos/${userId}`).then((r) => r.data);
